package one.healthium.paywall.ui

import androidx.compose.runtime.Immutable
import one.healthium.domain.paywall.models.Paywall
import one.healthium.domain.paywall.models.PaywallSet
import one.healthium.payments.models.ProductDetails
import one.healthium.payments.models.PurchaseOptions
import one.healthium.paywall.ui.models.ProductUiModel

@Immutable
data class PaywallUiState(
    val loading: Boolean = false,
    val paywall: Paywall? = null,
    val paywallSet: PaywallSet? = null,
    val productDetails: List<ProductDetails>? = null,
    val selectedProductId: String? = null,
    val paymentInProgress: Boolean = false,
) {
    val screenModel = paywall

    val products = productDetails?.map {
        ProductUiModel(it, paywall?.productDefaults)
    }

    val purchaseOptions by lazy {
        if (selectedProductId == null) return@lazy null

        val product = productDetails?.firstOrNull { productDetails -> productDetails.id == selectedProductId }

        if (product == null) return@lazy null

        PurchaseOptions(product = product)
    }
}
